import type {
	DataSourceDataParams,
	DataSourcePropGroupBy,
} from "@infinite-table/infinite-react";
import type { Pead, PriceDaily } from "epsm-api-types/models";
import { PEAD } from "./consts";

const useFiltering = true;
const defaultGroupBy: DataSourcePropGroupBy<Pead> = [];

const shouldReloadData = {
	sortInfo: true,
	filterValue: useFiltering,
};

const initialDataParams: Partial<DataSourceDataParams<Pead>> = {
	groupBy: defaultGroupBy,
};

const priceResponseFields: (keyof PriceDaily)[] = [
	"date",
	"adj_close",
	"adj_open",
];
const priceResponseFieldsForAll: (keyof PriceDaily)[] = ["date", "adj_close"];

const CHART_LINES = [
	PEAD.LINE.PRICE,
	PEAD.LINE.MIN,
	PEAD.LINE.MAX,
	PEAD.LINE.AVG,
	PEAD.LINE.SIGMA_1,
	PEAD.LINE.SIGMA_2,
	PEAD.LINE.SIGMA_MINUS_1,
	PEAD.LINE.SIGMA_MINUS_2,
];

const MIN_MAX_PADDING_IN_PERCENT = 0.03;
const CHART_PADDING = 0.02;

const COLORS = {
	BORDER: "#333",
	BACKGROUND: "#0c0a09",
};

export default {
	initialDataParams,
	useFiltering,
	defaultGroupBy,
	shouldReloadData,
	priceResponseFields,
	priceResponseFieldsForAll,
	CHART_LINES,
	CHART_PADDING,
	MIN_MAX_PADDING_IN_PERCENT,
	COLORS,
};
